import React from 'react'

// Verweis für Mounts ohne Router (#24, #107, #177): Shortcodes stehen auf
// beliebigen WordPress-Seiten, dort gibt es keinen RouterProvider — der
// Verweis muss die Seite wirklich wechseln, nicht clientseitig routen.
const PlainLink = ({ to, children, ...rest }) => <a href={to} {...rest}>{children}</a>

export default PlainLink
